module.exports = __webpack_public_path__ + "static/media/Chica-Jumpscare.0ce85db5.webp";